


<template>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
  <div class="login">
    <main>
      <div class="auth-wrapper d-flex align-items-center py-5">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
              <!-- Alert notifications -->
              <div class="alert alert-danger" v-if="error" role="alert">
                {{ error }}
              </div>
              <div class="alert alert-success" v-if="success" role="alert">
                {{ success }}
              </div>
  
              <div class="auth-card p-4">
                <!-- Header -->
                <div class="text-center mb-4">
                  <img src="../assets/neolink.png" alt="Logo" class="mb-3" style="width: 48px;">
                  <h1 class="fs-2 fw-bold">{{ t('login.title') }}</h1>
                  <p class="text-muted">{{ t('login.subtitle') }}</p>
                </div>
  
                <form @submit.prevent="handleLogin">
                  <!-- Login Form -->
                  <div class="bg-light p-4 rounded">
                    <div class="mb-3">
                      <input 
                        v-model="formData.email"
                        type="email" 
                        class="form-control" 
                        :placeholder="t('login.placeholder.email')" 
                        required
                      >
                    </div>
                    <div class="mb-3">
                      <div class="input-group">
                        <input 
                          v-model="formData.password"
                          :type="showPassword ? 'text' : 'password'" 
                          class="form-control" 
                          :placeholder="t('login.placeholder.password')" 
                          required
                        >
                        <button 
                          class="btn btn-outline-secondary" 
                          type="button"
                          @click="showPassword = !showPassword"
                        >
                          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between mb-3">
                      <div class="form-check">
                        <input 
                          v-model="formData.remember"
                          type="checkbox" 
                          class="form-check-input d-none" 
                          id="remember"
                        >
                        <label class="form-check-label d-none" for="remember">{{ t('login.rememberMe') }}</label>
                      </div>
                      <router-link to="/forgot-password" class="text-decoration-none">{{ t('login.forgotPassword') }}</router-link>
                    </div>
                  </div>
  
                  <!-- Buttons -->
                  <div class="d-grid gap-2 mt-4 mb-4">
                    <button 
                      type="submit" 
                      class="btn btn-primary"
                      :disabled="isLoading"
                    >
                      {{ isLoading ? t('login.loading') : t('login.signIn') }}
                    </button>
                    <router-link to="/inscription" class="btn btn-outline-primary">
                      {{ t('login.signUp') }}
                    </router-link>
                  </div>
                </form>
  
                <!-- Back to home -->
                <div class="text-center">
                  {{ t('login.backText') }} <router-link to="/" class="text-decoration-none">{{ t('login.homeLink') }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <TheFooter />
  </div>
</template>
 
 

 <script>
// AJOUTER ces imports :
import TheFooter from "@/components/layout/Footer.vue";
import { dashboardService } from '@/services/api';
import { useTranslation } from '@/composables/useTranslation';

export default {
  name: "LoginView",
  components: {
    TheFooter,
  },
  // AJOUTER cette fonction :
  setup() {
    const { t } = useTranslation()
    return { t }
  },
  // TON CODE EXISTANT RESTE IDENTIQUE :
  data() {
    return {
      formData: {
        email: '',
        password: '',
        remember: false
      },
      error: '',
      success: '',
      isLoading: false,
      showPassword: false
    }
  },
  methods: {
    async handleLogin() {
      try {
        this.isLoading = true;
        this.error = '';

        const response = await dashboardService.login(this.formData);

        if (response.data.success) {
          localStorage.setItem('user', JSON.stringify(response.data.data));
          // CHANGER ce message pour utiliser les traductions :
          this.success = this.t('login.success');
          
          setTimeout(() => {
            this.$router.push('/dashboard');
          }, 1000);
        }
      } catch (error) {
        // CHANGER ce message pour utiliser les traductions :
        this.error = error.response?.data?.message || this.t('login.error');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>


  <style lang="scss" scoped>
  /* Existing styles remain the same until the button styles */
  @import '@/assets/styles/main.scss';

  :root {
            --bs-primary: #000000;
        }
        
        .auth-wrapper {
            min-height: 100vh;
            background-color: #f8f9fa;
        }
        
        .auth-card {
            background: white;
            border-radius: 1rem;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        }
        
        .btn-social {
            width: 45px;
            height: 45px;
            transition: transform 0.3s;
        }
        
        .btn-social:hover {
            transform: translateY(-2px);
        }
        
        .social-login-text {
            position: relative;
        }
        
        .social-login-text::before,
        .social-login-text::after {
            content: '';
            position: absolute;
            top: 50%;
            width: 45%;
            height: 1px;
            background-color: #dee2e6;
        }
        
        .social-login-text::before { left: 0; }
        .social-login-text::after { right: 0; }
  /* Rest of your existing styles... */
  </style>

